export default __webpack_public_path__ + "static/home-bg-c84ff412e7f8346d6c403670ffcdfaaf.png";